import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const thunderboltInitializerSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'thunderboltInitializer'

export const config = {
	site: thunderboltInitializerSiteConfig,
	reactRendererSite: thunderboltInitializerSiteConfig,
	reactNativeSite: thunderboltInitializerSiteConfig,
	name,
}
